import { Injectable } from "@angular/core";
import { RateSubscription } from "../model/RateSubscription";
import { IRateSubscriptionService } from "../IRateSubscriptionService";
import { MarketDataEventImpl } from "shared/cubiq-model-multi-asset";

export abstract class RateSubscriptionPromiseService implements IRateSubscriptionService {
  abstract hasSubscription(rateSubscription: RateSubscription): Promise<boolean>;
  abstract getActiveSubscriptions(): Promise<Array<RateSubscription>>;
  abstract subscribe(subscription: RateSubscription): Promise<any>;
  abstract unsubscribe(subscription: RateSubscription): Promise<any>;
  abstract unsubscribeWithCheck(rateSubscription: RateSubscription): Promise<any>;
  abstract subscribeWithChecks(
    rateSubscriptions: Array<RateSubscription>,
  ): Promise<Array<RateSubscription>>;
  abstract unsubscribeWithChecks(
    rateSubscriptions: Array<RateSubscription>,
  ): Promise<Array<MarketDataEventImpl>>;
}
